import clsx from "clsx";
import { ChevronRightIcon } from "lucide-react";
import { bool, func } from "prop-types";

import classes from "./ChevronButton.module.scss";

const ChevronButton = ({ isEnabled, isExpanded, onClick }) => {
  return isEnabled ? (
    <button
      className={clsx(classes["chevron_button"], {
        [classes["chevron_button--expanded"]]: isExpanded,
      })}
      data-testid="chevron-button"
      onClick={onClick}
    >
      <ChevronRightIcon size={24} />
    </button>
  ) : (
    <div className={classes["chevron_button__dummy"]} />
  );
};

ChevronButton.propTypes = {
  isEnabled: bool,
  isExpanded: bool,
  onClick: func,
};

export default ChevronButton;
